import { t as escapeHtml } from "../html-CmvuXvc-.js";
import { z } from "zod";
// src/text/recipient.ts
function parseRecipient(value) {
	const named = /^\s*"?([^"<]*?)"?\s*<([^<>\s]+@[^<>\s]+)>\s*$/.exec(value);
	if (named) {
		const name = named[1].trim();
		return {
			address: named[2],
			...name ? { name } : {}
		};
	}
	return { address: value.trim() };
}
function namesMailAddress(value) {
	return z.regexes.unicodeEmail.test(parseRecipient(value).address);
}
function formatRecipient(value) {
	const { address, name } = parseRecipient(value);
	if (!name || !/[,;]/.test(name)) return value.trim();
	return `"${name.replaceAll("\"", "")}" <${address}>`;
}
function splitRecipients(line) {
	const recipients = [];
	let current = "";
	let quoted = false;
	let bracketed = false;
	for (const char of line) {
		if (char === "\"" && !bracketed) quoted = !quoted;
		if (char === "<" && !quoted) bracketed = true;
		if (char === ">" && !quoted) bracketed = false;
		if (!quoted && !bracketed && (char === "," || char === ";" || char === "\n")) {
			recipients.push(current);
			current = "";
			continue;
		}
		current += char;
	}
	recipients.push(current);
	return recipients.map((value) => value.trim()).filter(Boolean);
}
// src/text/time.ts
const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
// src/text/retry.ts
async function retryWithBackoff(fn, opts) {
	let lastErr;
	for (let attempt = 0; attempt < opts.maxRetries; attempt++) try {
		return await fn();
	} catch (err) {
		lastErr = err;
		if (attempt === opts.maxRetries - 1) break;
		await sleep(Math.min(opts.baseDelayMs * 4 ** (attempt + 1), opts.maxDelayMs));
	}
	opts.onExhausted(lastErr);
}
// src/text/slugify.ts
function slugify(name) {
	return name.toLowerCase().normalize("NFKD").replace(/\p{M}/gu, "").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
}
function slugifyBounded(value, maxLength, fallback) {
	const base = slugify(value).substring(0, maxLength).replace(/-+$/, "");
	return base.length > 0 ? base : fallback;
}
// src/text/truncate.ts
function truncateWithEllipsis(text, maxLen) {
	if (text.length <= maxLen) return text;
	return `${text.slice(0, maxLen - 3).trimEnd()}...`;
}
// src/text/unwrap.ts
const OPENS_ITEM = /^(?:[\p{Ll}\d]{1,4}[.)]|[-–—•])\s/u;
const CLOSES_SENTENCE = /[.!?:;]["'”»)\]]?\s*$/;
const OPENS_LOWER = /^[\p{Ll}(]/u;
function unwrapSoftBreaks(text) {
	return text.split(/\n{2,}/).map((paragraph) => {
		return paragraph.split("\n").reduce((joined, line) => {
			const soft = joined.length > 0 && !CLOSES_SENTENCE.test(joined) && OPENS_LOWER.test(line) && !OPENS_ITEM.test(line);
			return joined.length === 0 ? line : `${joined}${soft ? " " : "\n"}${line}`;
		}, "");
	}).join("\n\n");
}
export { escapeHtml, formatRecipient, namesMailAddress, parseRecipient, retryWithBackoff, sleep, slugify, slugifyBounded, splitRecipients, truncateWithEllipsis, unwrapSoftBreaks };

//# sourceMappingURL=index.js.map